import { connect } from 'react-redux'
import { getFromSettings } from 'src/utils/helpers'

import EPay from './EPay'

import { setCurrentlyOpenFeature } from 'src/modules/App/actions'

import { sendETransferEmail, submitEPayPaymentInformation, processEPayPayment } from '../actions'

const mapDispatchToProps = {
  setCurrentlyOpenFeature,
  sendETransferEmail,
  submitEPayPaymentInformation,
  processEPayPayment,
}

const mapStateToProps = state => {
  const countryIsoCode = getFromSettings(state, 'countryIsoCode')
  return {
    paymentPolicies: state.payment.paymentPolicies,
    selectedPaymentPolicies: state.payment.selectedPaymentPolicies,
    isEPayPaymentInformationInProgress: state.payment.isEPayPaymentInformationInProgress,
    submitEPayPaymentInformationResponse: state.payment.submitEPayPaymentInformationResponse,
    ePayPaymentInformationPayload: state.payment.ePayPaymentInformationPayload,
    isProcessEPayInProgress: state.payment.isProcessEPayInProgress,
    processEPayPaymentResponse: state.payment.processEPayPaymentResponse,
    processEPayPaymentPayload: state.payment.processEPayPaymentPayload,
    isEPayPolicy: state.payment.isEPayPolicy,
    isWidgetState: state.appReducer.isWidget,
    labels: getFromSettings(state, 'labels', {}),
    brand: getFromSettings(state, 'brand', {}),
    user: state.user.user,
    features: state.appReducer.features,
    language: state.appReducer.language,
    countryIsoCode: countryIsoCode,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EPay)
